import { createGlobalState, useAsyncState } from "@vueuse/core";
import { REQUEST_CODES } from "~/constants/const-http";
import { gePlatformAdvertBanner } from "~/services/common";

/**
 * 推荐广告位
 */
// 15 首页 25 邮轮搜索结果 26 线路搜索结果 27 全站搜索结果 27 行业资讯 28 原创资讯
export default function usePlatformAdvertBanner(type) {
  const { state } = useAsyncState(async () => {
    const { code, data, msg } = await gePlatformAdvertBanner({type});
    if (code !== REQUEST_CODES.ERROR_OK) {
      throw new Error(msg)
    }
    return data
  }, [], {})


  return {
    state
  }
}
